import { Box } from "@mui/material"
import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { AppState } from "../../../core/app/AppReducer"
import GlowMode from "../../../core/assets/oot/classic/GlowGoModeLigth.gif"
import GoModeGif from "../../../core/assets/oot/classic/GoModeLigth.gif"
import { setItems } from "../../OotrReducer"



const GoMode = () => {

    let id = "Go Mode";
    const dispatch = useDispatch();
    const gotLigthArrow = useSelector((state: AppState) => state.ui.ootr.main.items.some(x => x.id === "OoT_LightArrow" && x.isObtained))
    const reduce = useSelector((state: AppState) => state.ui.ootr.main.useItemTrackerReduce)


    const [inGoMode, setInGoMode] = useState<boolean>(false)


    const updateGoModeState = () => {
        setInGoMode(!inGoMode);
        dispatch(setItems({ id: id, isChecked: false, isObtained: !inGoMode, state: 0, title: "Go Mode" }))
    }
    if(reduce)
        return <Box display="flex" width="32px" height="32px" textAlign={"center"} onClick={() => { updateGoModeState() }}>
            {inGoMode && !gotLigthArrow && <img style={{position: "absolute", top: 140, left : 150, zIndex: 999999}} src={GlowMode} alt="glow mode" width={"200px"} height={"200px"} onClick={() => { updateGoModeState() }}/>}
            {inGoMode && gotLigthArrow && <img style={{position: "absolute", top: 140, left : 150, zIndex: 999999}} src={GoModeGif} alt="glow mode" width={"200px"} height={"200px"} onClick={() => { updateGoModeState() }}/>}
        </Box>

    return <Box display="flex" width="32px" height="32px" textAlign={"center"} onClick={() => { updateGoModeState() }}>
            {inGoMode && !gotLigthArrow && <img style={{position: "absolute", top: 130, left : 115, zIndex: 999999}} src={GlowMode} alt="glow mode" width={"200px"} height={"200px"} onClick={() => { updateGoModeState() }}/>}
            {inGoMode && gotLigthArrow && <img style={{position: "absolute", top: 130, left : 115, zIndex: 999999}} src={GoModeGif} alt="glow mode" width={"200px"} height={"200px"} onClick={() => { updateGoModeState() }}/>}
        </Box>
}

export default GoMode;